export const CLIENT_SETTING_KEYS = {
    // ── City Object Detail tabs ───────────────────────────────────────────
    ENABLE_CO_TAB_SELF_DELIVERY: 'ENABLE_CO_TAB_SELF_DELIVERY',

    // ── Settings ──────────────────────────────────────────────────────────
    ENABLE_SUBSCRIBERS: 'ENABLE_SUBSCRIBERS',
    ENABLE_DEPUTIES: 'ENABLE_DEPUTIES',
    ENABLE_CONTRACT_CREWS: 'ENABLE_CONTRACT_CREWS',
    ENABLE_CONTRACT_MACHINES: 'ENABLE_CONTRACT_MACHINES',
    FEATURE_USER_DEFAULTS: 'FEATURE_USER_DEFAULTS',
 

    // ── City Object Detail tabs ───────────────────────────────────────────
    ENABLE_CO_TAB_CONTRACT_MEMO: 'ENABLE_CO_TAB_CONTRACT_MEMO',
    FEATURE_STARA_OBJECT_FIELDS: 'FEATURE_STARA_OBJECT_FIELDS',

    // ── City Object tabs ─────────────────────────────────────────────────
    ENABLE_CO_TAB_DEVIATION: 'ENABLE_CO_TAB_DEVIATION',
    ENABLE_CO_TAB_EXCEPTION_REPORT: 'ENABLE_CO_TAB_EXCEPTION_REPORT',
    ENABLE_CO_TAB_MVR: 'ENABLE_CO_TAB_MVR',
    ENABLE_CO_TAB_ACTION_HISTORY: 'ENABLE_CO_TAB_ACTION_HISTORY',

    // ── Reports ───────────────────────────────────────────────────────────
    ENABLE_SEARCH_PRINTOUTS: 'ENABLE_SEARCH_PRINTOUTS',
    ENABLE_FILES: 'ENABLE_FILES',
    ENABLE_SITE_MEETING_REPORT: 'ENABLE_SITE_MEETING_REPORT',
    ENABLE_ANNUAL_SUMMARY: 'ENABLE_ANNUAL_SUMMARY',
    ENABLE_INVOICE_REPORT: 'ENABLE_INVOICE_REPORT',
    ENABLE_INVOICING_REPORT: 'ENABLE_INVOICING_REPORT',
    ENABLE_CONTRACT_DIARY_REPORT: 'ENABLE_CONTRACT_DIARY_REPORT',
    ENABLE_TO_CONTRACTOR_REPORT: 'ENABLE_TO_CONTRACTOR_REPORT',
    ENABLE_UNIT_PRICES: 'ENABLE_UNIT_PRICES',
    ENABLE_OPEN_POWERBI_SUMMARY_REPORT: 'ENABLE_OPEN_POWERBI_SUMMARY_REPORT',
    ENABLE_DEDUCTION_RELEASE: 'ENABLE_DEDUCTION_RELEASE',
} as const;

export type ClientSettingKey = typeof CLIENT_SETTING_KEYS[keyof typeof CLIENT_SETTING_KEYS];
